import { observable, action, runInAction } from 'mobx'
import { json } from '../../../../../utils/ajax'
import { message } from 'antd'


class faultDiagnosisIndex{

  @observable loading
  @observable carSeriesId //选择的车系
  @observable menu    //故障诊断目录
  @observable search  //查询值
  @observable codeContent  //故障码总表内容
  @observable childrenDirectory  //点击1级目录后的二三级目录
  @observable level4List    //四级目录列表
  @observable codeList      //故障代码表
  @observable level3SelectedName //点击的三级目录名称


  constructor () {
    this.loading = false
    this.carSeriesId = ''
    this.menu = []
    this.childrenDirectory = []
    this.search = {}
    this.level4List = []
    this.codeList = []
    this.level3SelectedName = ''
  }


  @action
  initMenu = async(id,level3) =>{
    runInAction(()=>{
      this.loading = true;
      this.carSeriesId = id;
      this.level4List = []
      this.codeList = []
    })
    const menu = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/faultDiagnosis/faultDiagnosisCatalog/queryFirstThreeLevels?carseriesId=${id}`)
    if(menu && menu.status === 0){
      runInAction(()=>{
        this.loading = false
      })
      return
    }
    if(level3 && level3 !== 'none'){
      const level3Detail = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/faultDiagnosis/faultDiagnosisCatalog/${level3}`)
      if(level3Detail && level3Detail.status === 0){
        runInAction(()=>{
          this.loading = false;
        })
        return
      }
      const level4 = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/faultDiagnosis/faultDiagnosisCatalog/queryOffspringCatalogThroughState?carseriesId=${this.carSeriesId}&level=3&id=${level3}`)
      if(level4 && level4.status === 0){
        runInAction(()=>{
          this.loading = false;
        })
        return
      }
      runInAction(()=>{
        this.level3SelectedName = level3Detail.defaultName
        this.level4List = level4
      })
    }
    runInAction(()=>{
      this.menu = menu;
      if(menu.length!==0){
          this.childrenDirectory = menu[0].children
      }else{
        this.childrenDirectory =''
      }
      this.loading = false;
    })
  }

  @action
  showChildrenDirectory = (id) =>{
    let arr = []
    arr = this.menu.filter(item=> item.id === id)
    runInAction(()=>{
      this.childrenDirectory = arr[0].children
    })
  }
  /**
   * 每次更新search框时，回写数据
   * @param values search数据
   */
  @action
  onSearchFieldChange(values) {
    runInAction(() => {
      this.search = values
    })
  }
  @action showDescription = async(id) =>{
    runInAction(()=>{
      this.loading = true;
      this.level3SelectedName = ''
    })
    const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/faultDiagnosis/faultDiagnosisCatalog/queryListVague?carseriesId=${id}&defaultName=${this.search}`)
    if(res && res.status){
      runInAction(()=>{
        this.loading = false;
      })
      return
    }
    if(res.length === 0){
      message.warning('没有搜索到内容哟！')
    }
    runInAction(()=>{
      this.level4List = res
      this.loading = false;
    })
  }
  @action showCode = async(id) =>{
    runInAction(()=>{
      this.loading = true;
      this.level3SelectedName = ''
    })
    const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/faultDiagnosis/faultDiagnosisCatalog/queryListVagueByIsCode?carseriesId=${id}&defaultName=${this.search}`)
    if(res && res.status){
      runInAction(()=>{
        this.loading = false;
      })
      return
    }
    if(res.length === 0){
      message.warning('没有搜索到内容哟！')
    }
    runInAction(()=>{
      this.codeList = res
      this.loading = false;
    })
  }
  @action showLevel4Menu = async(id,name) =>{
    runInAction(()=>{
      this.loading = true;
      this.level3SelectedName = name;
    })
    const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/faultDiagnosis/faultDiagnosisCatalog/queryOffspringCatalogThroughState?carseriesId=${this.carSeriesId}&level=3&id=${id}`)
    if(res && res.status === 0){
      runInAction(()=>{
        this.loading = false;
      })
      return
    }
    if(res.length === 0){
      message.warning('没有搜索到内容哟！')
    }
    runInAction(()=>{
      this.level4List = res
      this.loading = false;
    })
  }
}

export default new faultDiagnosisIndex()


// WEBPACK FOOTER //
// ./src/project/dongfeng/faultDiagnosis/main/IndexDiagnosis/store.js